<template>
    <div class="login">
        <div class="login-container">
            <div class="login-wrap" v-if="isChrome">
                <h1 class="login-title">欢迎回来</h1>
                <el-form :model="loginData" ref="loginData">
                    <el-form-item
                        prop="phone"
                        :rules="[
                            { required: true, message: ' ', trigger: 'blur' },
                            {
                                pattern: /^1[3456789]\d{9}$/,
                                message: '手机号格式不正确，请重新填写',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-input
                            v-model.number="loginData.phone"
                            maxlength="11"
                            placeholder="请输入手机号"
                            prefix-icon="fishdicon fishdicon-user-line"
                        ></el-input>
                    </el-form-item>
                    <template v-if="isPassword">
                        <el-form-item
                            prop="password"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="loginData.password"
                                type="password"
                                placeholder="请输入密码"
                                prefix-icon="fishdicon fishdicon-lock-line"
                            ></el-input>
                            <!-- <el-link type="primary" :underline="false" @click="isPassword = !isPassword">忘记密码？</el-link> -->
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item
                            prop="password"
                            :rules="[
                                { required: true, message: ' ', trigger: 'blur' },
                                { pattern: /\d{4}$/, message: ' ', trigger: 'blur' }
                            ]"
                        >
                            <el-input
                                v-model="loginData.password"
                                maxlength="4"
                                prefix-icon="fishdicon fishdicon-lock-line"
                                style="color: rgba(0, 0, 0, 0.25)"
                                placeholder="请输入验证码"
                            >
                                <el-link type="primary" :underline="false" slot="append"
                                    >获取验证码</el-link
                                >
                            </el-input>
                            <el-link
                                type="primary"
                                :underline="false"
                                @click="isPassword = !isPassword"
                                >密码登录</el-link
                            >
                        </el-form-item>
                    </template>
                    <el-form-item>
                        <el-button
                            type="primary"
                            class="login-btn"
                            :loading="loginData.loading"
                            @click="SubmitLogin('loginData')"
                            >登 录</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isChrome: false,
            isPassword: true,
            loginData: {
                phone: null,
                password: null,
                loading: false
            }
        }
    },
    created() {
        this.$nextTick(() => {
            if (navigator.userAgent.indexOf('Chrome') > -1 === false) {
                this.$confirm(
                    '检测到您的浏览器不是chrome浏览器，可能存在安全风险或导致页面无法正常显示，为了能够不影响您正常使用，建议您使用chrome浏览器再尝试打开网站！',
                    '安全警告',
                    {
                        showClose: false,
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        confirmButtonText: '安装最新版chrome浏览器'
                    }
                )
                    .then(() => {
                        window.location.href = 'https://www.google.cn/chrome/'
                    })
                    .catch(() => {})
            } else {
                this.isChrome = true
            }
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        // 获取当前用户信息和企业信息
        GetInfo() {
            this.$request({
                url: '/api/v1/users/info'
            }).then(res => {
                if (!res.status) {
                    this.$store.commit('setEnterprise', {
                        id: res.data.enterprise.id,
                        domain: res.data.enterprise.domain,
                        name: res.data.enterprise.name,
                        invite: res.data.enterprise.invite_code
                    })
                    this.$store.commit('setUser', {
                        id: res.data.id,
                        avatar: res.data.avatar,
                        name: res.data.name,
                        phone: res.data.phone,
                        email: res.data.email,
                        identity: res.data.identity_id
                    })
                    this.$router.replace({
                        path: '/'
                    })
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        SubmitLogin(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loginData.loading = true
                    this.$request({
                        url: '/api/v1/login',
                        params: this.loginData
                    }).then(res => {
                        this.loginData.loading = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.$store.commit('setToken', res.data.token)
                            this.GetInfo()
                        }
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.login {
    &-container {
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('https://ysf.nosdn.127.net/operation/5162b5c91ace0f18d09c52ca1e337865'),
            url('https://ysf.nosdn.127.net/operation/27fe26ee7f9c1d230440147081094faa');
        background-color: #4343bf;
        background-repeat: no-repeat, repeat;
        background-size: 100% auto, 400px 400px;
        background-position: bottom, bottom;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        min-height: 700px;
        position: relative;
    }
    &-wrap {
        width: 420px;
        height: 560px;
        padding: 80px 50px 0;
        border-radius: 8px;
        background-color: #fff;
        background-image: url('https://ysf.nosdn.127.net/operation/4bc76fe71fd89393919cde945c4e332a'),
            url('https://ysf.nosdn.127.net/operation/99624422ee25c5c87f87d20a5529c338');
        background-repeat: no-repeat;
        background-position: 0 0, 100% 100%;
    }
    &-title {
        margin-bottom: 40px;
        font-size: 34px;
        font-weight: normal;
        line-height: 32px;
        color: #222;
    }
    &-btn {
        margin-top: 10px;
        width: 100%;
    }
}
</style>
